import { EntitlementsApi } from "@entitlements/api-client"
import { ApiModels as M } from "@entitlements/api-models"
import { mockEntitlementsApi } from "@entitlements/client"
import { LuxedoRPC } from "luxedo-rpc"
import { ApiClient } from "rest-api-client"

class Api implements EntitlementsApi {
	private genApiClient() {
		const headers = new Headers()
		headers.append("X-Csrftoken", LuxedoRPC.getCsrfToken())
		headers.append("Content-Type", "application/json")
		return new ApiClient(`${import.meta.env.VITE_API_URL}/api/subscriptions`, {
			headers,
			credentials: "include",
		})
	}

	async fetchCustomer(customerId: string): Promise<M["Customer"]> {
		const api = this.genApiClient()
		const res: M["Customer"] = await api.get(`/customers/${customerId}`)
		return res
	}

	async fetchCustomerSubscriptions(customerId: string): Promise<M["Subscription"][]> {
		const api = this.genApiClient()

		const res: M["Subscription"][] = await api.get(`/customers/${customerId}/subscriptions`)
		return res
	}

	async linkCustomerSubscription(
		customerId: string,
		subscriptionId: string,
		subscriptionEmail: string,
	): Promise<void> {
		const api = this.genApiClient()
		const res = await api.post(`/customers/${customerId}/subscriptions`, {
			subscription_id: subscriptionId,
			subscription_email: subscriptionEmail,
		})
	}
}

// export const entitlementsApi = import.meta.env.VITE_MOCK_SUBSCRIPTION_API
// 	? mockEntitlementsApi
// 	: new Api()
export const entitlementsApi = new Api()
